/**
 * @file        src/components/DocPaymentSplit.jsx
 * @description "Payment Details" — the instrument breakdown behind a printed
 *              document's total. A booking can be settled part from the wallet
 *              and part by card, and an invoice that prints only one number
 *              implies the whole amount went through the gateway.
 *
 *              Renders nothing when the split is unknown (a booking predating
 *              the wallet_paid / gateway_paid columns), so an older invoice
 *              reprints exactly as it did before.
 *
 *              The wallet line is deliberately tenant-neutral ("Paid from
 *              Wallet"): the customer's neon build names its own wallet, which
 *              the admin console — shared by every tenant — must not do.
 * @author      Kinetika Labs
 * @created     2026-09-10
 * @changelog
 *   - 2026-09-10 Claude — Extracted verbatim from flight/InvoiceDoc.jsx so the
 *                          hotel invoice can print the same block instead of a
 *                          third copy of it. The hotel invoice printed no
 *                          payment breakdown at all, while the guest's own copy
 *                          of the same invoice did.
 */

const rupee = (v) => `₹${(Number(v) || 0).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;

export default function DocPaymentSplit({ split }) {
  const wallet = Number(split?.walletPaid) || 0;
  const gateway = Number(split?.gatewayPaid) || 0;
  if (wallet <= 0 && gateway <= 0) return null;
  const rows = [];
  if (wallet > 0) rows.push(['Paid from Wallet', wallet]);
  if (gateway > 0) rows.push(['Paid by Payment Gateway', gateway]);
  return (
    <div className="doc-pay">
      <p className="doc-pay-h">Payment Details</p>
      {rows.map(([label, amt]) => (
        <div className="doc-trow" key={label}>
          <span>{label}</span><b>{rupee(amt)}</b>
        </div>
      ))}
    </div>
  );
}
